import AbsolutePane from './_absolute-pane.js'
import BetslipNotifications from './_betslip-notifications.js'

export default {
  name: 'PlacementMessages',
  values: {
    container: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          left: '8px',
          right: '8px',
          bottom: '-6px',
        },
      },
    },
    errors: {
      configSet: BetslipNotifications,
      configValues: {
        notificationsMap: {
          MULTIPLIER_BREACH: 'info',
        },
        info: {
          text: {
            container: {
              padding: '0 0 0 8px',
            },
          },
          icon: {
            src: 'exclamation-mark',
            style: {
              minWidth: '16px',
              minHeight: '16px',
            },
          },
        },
      },
    },
    errorsTimeout: 4,
  },
  meta: {
    extendable: false,
  },
}
